import { RefreshCw, Heart, PiggyBank } from 'lucide-react'
import { cn } from '@/lib/utils'

const features = [
  {
    icon: PiggyBank,
    title: 'Predictable Budget',
    description:
      'You define the monthly contribution. No surprise renewals or 15% annual hikes. You control the cost.',
    iconBg: 'bg-orange-50',
    iconColor: 'text-orange-primary',
    hoverBorder: 'hover:border-orange-200',
  },
  {
    icon: Heart,
    title: 'Personalized Choice',
    description:
      'Employees shop a marketplace of plans tailored to their doctors, prescriptions, and budget. One size does not fit all.',
    iconBg: 'bg-orange-50',
    iconColor: 'text-orange-primary',
    hoverBorder: 'hover:border-orange-200',
  },
  {
    icon: RefreshCw,
    title: 'Automated Payroll Sync',
    description:
      'Connect your payroll provider in one click. We handle deductions and enrollments automatically.',
    iconBg: 'bg-orange-50',
    iconColor: 'text-orange-primary',
    hoverBorder: 'hover:border-orange-200',
  },
]

export const ValueProposition = () => {
  return (
    <section
      className="py-20 sm:py-28 lg:py-32 px-4 sm:px-6 lg:px-8 bg-neutral-100"
      id="product"
    >
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-14 sm:mb-16 lg:mb-20">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-semibold tracking-tight text-neutral-900 leading-tight">
            Designed for HR. <br className="hidden sm:block" />
            <span className="text-neutral-400">Loved by Employees.</span>
          </h2>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5 sm:gap-6 lg:gap-8">
          {features.map((feature, index) => {
            const Icon = feature.icon
            return (
              <div
                key={index}
                className={cn(
                  'group relative',
                  'bg-white p-7 sm:p-8 lg:p-10 rounded-2xl sm:rounded-3xl',
                  'border border-neutral-200/80',
                  'shadow-sm',
                  'transition-all duration-300 ease-out',
                  'hover:shadow-xl hover:shadow-neutral-200/60',
                  'hover:-translate-y-1',
                  feature.hoverBorder
                )}
              >
                <div
                  className={cn(
                    'w-12 h-12 sm:w-14 sm:h-14 rounded-xl sm:rounded-2xl',
                    'flex items-center justify-center',
                    'mb-6 sm:mb-8',
                    feature.iconBg,
                    'transition-transform duration-300',
                    'group-hover:scale-110'
                  )}
                >
                  <Icon
                    className={cn(
                      'w-6 h-6 sm:w-7 sm:h-7',
                      feature.iconColor,
                      'transition-transform duration-300'
                    )}
                    strokeWidth={1.8}
                  />
                </div>

                <h3 className="text-lg sm:text-xl font-bold mb-3 sm:mb-4 text-neutral-900">
                  {feature.title}
                </h3>
                <p className="text-sm sm:text-base leading-relaxed text-neutral-500">
                  {feature.description}
                </p>
              </div>
            )
          })}
        </div>
      </div>
    </section>
  )
}
